import { Chip, styled } from '@mui/joy';

export const BaseTableChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.isDarkMode
    ? theme.palette.neutral[500]
    : theme.palette.neutral[50],
  span: {
    color: theme.palette.isDarkMode
      ? theme.palette.neutral[900]
      : theme.palette.neutral[900],
  },
  color: theme.palette.isDarkMode
    ? theme.palette.neutral[900]
    : theme.palette.neutral[50],
  '&:hover': {
    backgroundColor: 'none',
  },
  borderColor: theme.palette.isDarkMode
    ? theme.palette.neutral[500]
    : theme.palette.neutral[300],
}));
